module.exports = __webpack_public_path__ + "img/airtech.71e85146.webp";